import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: 'https://ca315d40caf24c0b821b49191d724d14@sentry.io/1453995',
  release: `sketch-marketing-web@${window.SENTRY_RELEASE_NAME}`,
})
